import { render, staticRenderFns } from "./preview-gas-db-record-dialog.component.vue?vue&type=template&id=999f71e8"
import script from "./preview-gas-db-record-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./preview-gas-db-record-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports